
import { Shield } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";

const SecurityTab = ({ formData, setFormData }) => {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Shield className="h-4 w-4" />
            Proctoring Settings
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <Label htmlFor="proctoring-enabled">Enable Proctoring</Label>
              <p className="text-xs text-gray-500">
                Monitor candidates during the exam
              </p>
            </div>
            <Switch
              id="proctoring-enabled"
              checked={formData.proctoring.enabled}
              onCheckedChange={(checked) =>
                setFormData((prev) => ({
                  ...prev,
                  proctoring: {
                    ...prev.proctoring,
                    enabled: checked,
                  },
                }))
              }
            />
          </div>

          {formData.proctoring.enabled && (
            <>
              <div className="flex items-center justify-between">
                <Label htmlFor="capture-images">Capture Images</Label>
                <Switch
                  id="capture-images"
                  checked={formData.proctoring.captureImages}
                  onCheckedChange={(checked) =>
                    setFormData((prev) => ({
                      ...prev,
                      proctoring: {
                        ...prev.proctoring,
                        captureImages: checked,
                      },
                    }))
                  }
                />
              </div>

              <div className="flex items-center justify-between">
                <Label htmlFor="track-tab-switching">Track Tab Switching</Label>
                <Switch
                  id="track-tab-switching"
                  checked={formData.proctoring.trackTabSwitching}
                  onCheckedChange={(checked) =>
                    setFormData((prev) => ({
                      ...prev,
                      proctoring: {
                        ...prev.proctoring,
                        trackTabSwitching: checked,
                      },
                    }))
                  }
                />
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <Label htmlFor="face-detection">Face Detection</Label>
                  <p className="text-xs text-gray-500">
                    Monitor candidate's face presence during exam
                  </p>
                </div>
                <Switch
                  id="face-detection"
                  checked={formData.proctoring.faceDetection}
                  onCheckedChange={(checked) =>
                    setFormData((prev) => ({
                      ...prev,
                      proctoring: {
                        ...prev.proctoring,
                        faceDetection: checked,
                      },
                    }))
                  }
                />
              </div>
            </>
          )}

          <div>
            <Label htmlFor="warnings-allowed">Warnings Allowed</Label>
            <Input
              id="warnings-allowed"
              type="number"
              min="0"
              value={formData.warningsAllowed}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  warningsAllowed: parseInt(e.target.value),
                }))
              }
            />
            <p className="text-xs text-gray-500 mt-1">
              Number of warnings before disqualification
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SecurityTab;